'use client';

import { signIn, signOut } from 'next-auth/react';
import { useTranslations } from 'next-intl';

export const LoginAgainButton = () => {
  const t = useTranslations('LoginAgainButton');

  return (
    <button
      className="btn btn-primary"
      onClick={() => {
        signOut({ redirect: false }).finally(() =>
          signIn('keycloak', { redirectTo: '/' }),
        );
      }}
    >
      {t('login-again')}
    </button>
  );
};
